module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Project-Price"
  }, [_c('div', {
    staticClass: "Project-Price-Subtotal"
  }, [_c('span', [_vm._v("Netto gesamt")]), _vm._v(" "), _c('span', {
    staticClass: "Project-Price-Subtotal-Price"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Price-Netto']) + "\n        ")]), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
    staticClass: "Project-Price-Subtotal-Time"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Time-Long']) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l(({
    '5': _vm.milestones['Taxes-5-Long'],
    '7': _vm.milestones['Taxes-7-Long'],
    '16': _vm.milestones['Taxes-16-Long'],
    '19': _vm.milestones['Taxes-19-Long']
  }), function(taxes_value, taxes_key) {
    return _c('div', {
      staticClass: "Project-Price-Taxes",
      class: taxes_value == 0 || taxes_value === undefined ? 'is-empty' : ''
    }, [(taxes_value != 0 && taxes_value !== undefined) ? _c('span', [_vm._v("USt. " + _vm._s(taxes_key) + "% gesamt")]) : _vm._e(), _vm._v(" "), (taxes_value != 0 && taxes_value !== undefined) ? _c('span', {
      staticClass: "Project-Price--Subtotal-Price"
    }, [_vm._v("\n            " + _vm._s(taxes_value) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
      staticClass: "Project-Price-Subtotal-Time"
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "Project-Price-Total"
  }, [_c('span', [_vm._v("Brutto gesamt")]), _vm._v(" "), _c('span', {
    staticClass: "Project-Price-Subtotal-Price"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Price-Brutto']) + "\n        ")]), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
    staticClass: "Project-Price-Subtotal-Time"
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599e18c1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/PriceTable.vue
// module id = 165
// module chunks = 4